export const SUPPORTED_LANGUAGES = ['ru', 'en'] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

/** Laplace x GTM sells in the US first: English unless the visitor picks Russian. */
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en'

export function isSupportedLanguage(
  value: unknown,
): value is SupportedLanguage {
  return (
    typeof value === 'string' &&
    SUPPORTED_LANGUAGES.some((language) => language === value)
  )
}

/**
 * Languages visitors can reach. Russian is hidden while Laplace x GTM sells
 * in the US: /ru/... redirects to English, the language toggle is gone, and
 * nothing in Russian is prerendered or listed. Add 'ru' back to show it.
 */
export const LIVE_LANGUAGES: ReadonlyArray<SupportedLanguage> = ['en']

export function isLiveLanguage(value: unknown): value is SupportedLanguage {
  return isSupportedLanguage(value) && LIVE_LANGUAGES.includes(value)
}

export function resolvePreferredLanguage(): SupportedLanguage {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE
  const stored = window.localStorage.getItem('ui-language')
  if (isLiveLanguage(stored)) return stored
  return DEFAULT_LANGUAGE
}
